import { Cache } from 'client/utils/cache';

// cache instance for API client purposes
export const apiCache = new Cache({ max: 100000 });
